module.exports = __webpack_public_path__ + "img/arrow_down_3.0a4fe91c.svg";